import { CorrelationAssetsRequest } from '@core/market-data-sdk/interface';
import { formatDate } from '../../utils/date-helper';

export const createCorrelationSeries = (
  series: Props[]
): CorrelationAssetsRequest[] => {
  return series.map((item) => ({
    identifier: item.name,
    color: item.color,
    quotes: item?.data?.map(([d, c]) => ({
      d: formatDate(d, 'YYYY-MM-DD'),
      c,
    })),
  }));
};

interface Props {
  color: string;
  id: string;
  name: string;
  data: number[][];
}
